import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { Dropdown, Badge } from "react-bootstrap";

const EGFilter = props => {
    const { onFilter, className } = props;
    const [category, setCategory] = useState([]);
    const [selected, setSelected] = useState([]);

    const egListById = useSelector((state) => state.crewKanban.egListById);
    const crews = useSelector((state) => state.crewKanban.crews);

    const egIds = useMemo(() => {
        return Object.keys(crews).map((crew) => crews[crew].egList).flat().map(e => e.id);
    }, [crews]);

    const egList = useMemo(() => {
        const egList = [];
        if (egIds.length === 0) return egList;
        for (const egId of egIds) {
            if (!egListById[egId]) continue;
            egList.push(egListById[egId]);
        }
        return egList;
    }, [egListById, egIds])

    useEffect(() => {
        const category = [], selectedItems = [];

        for (const item of egList) {
            const name = item.primary_category_name;
            if (!name || category.indexOf(name) >= 0) continue;
            if (selected.indexOf(name) >= 0) selectedItems.push(name);
            category.push(name);
        }

        setCategory(category);
        setSelected(selectedItems);
        onFilter(getFilterEGIds(selectedItems));
    }, [egList])

    const onSelect = (name, checked) => {
        const selectedItems = [...selected];
        if (checked) selectedItems.push(name);
        else selectedItems.splice(selectedItems.indexOf(name), 1);
        setSelected(selectedItems);
        onFilter(getFilterEGIds(selectedItems));
    };

    const getFilterEGIds = selected => {
        if (selected.length > 0) {
            return egList
                .filter(e => selected.indexOf(e.primary_category_name) >= 0)
                .map(e => e.equipment_group_uuid);
        }
        else return null;
    }

    return <Dropdown className={className}>
        <Dropdown.Toggle className="filter-dropdown-toggle">
            <i className="fa fa-filter filter-btn" title="Filter" />
            {selected.length > 0 && <Badge
                variant="warning"
                className="badge-filter-count">
                {selected.length}
            </Badge>}
        </Dropdown.Toggle>
        <Dropdown.Menu >
            {category.map(name => {
                return <div key={name} className={`filter-dropdown-item-custom`}>
                    <label>
                        <span>
                            <input
                                type="checkbox"
                                checked={selected.indexOf(name) >= 0}
                                onChange={(e) => onSelect(name, e.target.checked)}
                            />
                        </span>
                        <span className="item-text">{name}</span>
                    </label>
                </div>;
            })}
        </Dropdown.Menu>
    </Dropdown>;
};

export default EGFilter;